<template>
  <div v-loading="!isParsed">
    <el-table
      v-if="isParsed"
      :data="paginatedParsed"
      stripe
      size="mini"
      style="overflow-x: scroll;"
    >
      <template v-for="(key, index) in Object.keys(parsed[0])">
        <el-table-column
          :key="index"
          :label="key"
          :prop="key"
        >
          <template slot-scope="props">
            {{ props.row[key] ? props.row[key] : '-' }}
          </template>
        </el-table-column>
      </template>
    </el-table>
    <!-- Pagination -->
    <br>
    <div style="text-align: center;">
      <el-pagination
        :current-page.sync="page"
        :page-sizes="[5, 10, 20, 30]"
        :page-size.sync="perPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      parsed: [],
      isParsed: false,
      page: 1,
      perPage: 5,
      total: 0
    }
  },
  computed: {
    paginatedParsed () {
      let startIndex = (this.page * this.perPage) - this.perPage
      let endIndex = startIndex + this.perPage
      return this.parsed.slice(startIndex, endIndex)
    }
  },
  created () {
    this.$sheep.parseFileToArray(this.form.file.raw, contents => {
      this.parsed = contents
      this.total = this.parsed.length
      this.isParsed = true
    })
  },
  methods: {
    next () {
      this.$emit('submitted', this.parsed)
    }
  }
}
</script>

<style>

</style>
